// extracted by mini-css-extract-plugin
module.exports = {"popup":"chapter-popup_popup__1Z9qL"};